module.exports = __webpack_public_path__ + "img/logo_stripped.71b60a58.png";